export default "__VITE_ASSET__97e8f753__"